import { AlertPriority } from '@ixicare/resources';

/**
 * Which file each priority plays. Asset mapping only.
 */
export const alertSounds: Record<AlertPriority, string> = {
  [AlertPriority.Critical]: 'alert_critical.mp3',
  [AlertPriority.Urgent]: 'alert_urgent.mp3',
  [AlertPriority.Manual]: 'alert_manual.mp3',
  [AlertPriority.Informative]: 'alert_informative.mp3',
  [AlertPriority.DeviceCritical]: 'alert_devices_critical.mp3',
  [AlertPriority.DeviceNonCritical]: 'alert_devices_non_critical.mp3',

  // Legacy spellings, being retired in favour of the DEVICE_* ones.
  [AlertPriority.Magenta]: 'alert_devices_critical.mp3',
  [AlertPriority.Purple]: 'alert_devices_non_critical.mp3',
};

/**
 * Priorities that stay silent. Mirrors SILENT_PUSH_PRIORITIES in the backend's
 * `alerts_v2/service_layer/push_notifications.py`; keep the two in step.
 * MAGENTA/PURPLE are deliberately absent there and so absent here.
 */
const SILENT_PRIORITIES: ReadonlySet<AlertPriority> = new Set([
  AlertPriority.DeviceCritical,
  AlertPriority.DeviceNonCritical,
]);

/**
 * Whether an alert should produce audio. Filter with this *before* handing
 * priorities to SoundService: `start()` only ever plays the first active type,
 * so a soundless priority left in that list swallows the sound of a co-active
 * audible alert.
 *
 * `isSilent` is the backend's per-push `is_silent` flag and is authoritative
 * when present. Nothing in the dashboard carries it today; the parameter exists
 * so this stays call-compatible with the mobile app's shouldPlayAlertSound.
 */
export const shouldPlayAlertSound = (priority: AlertPriority, isSilent?: boolean) =>
  !(isSilent ?? SILENT_PRIORITIES.has(priority));
